import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import PromptSuggestionRecord from "models/view-models/conversations/prompt-suggestions/prompt-suggestion-record";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
export interface ChatPromptSuggestionButtonProps {
    onClick: (prompt: PromptSuggestionRecord) => void;
    prompt: PromptSuggestionRecord;
}
const CSS_CLASS_NAME = "c-chat-prompt-suggestion-button";
const ChatPromptSuggestionButton = ({
    onClick,
    prompt,
}: ChatPromptSuggestionButtonProps) => {
    return (
        <Button
            style={ButtonStyles.None}
            cssClassName={CSS_CLASS_NAME}
            onClick={() => onClick(prompt)}>
            <Icon
                type={Icons.Prompt}
                cssClassName={`${CSS_CLASS_NAME}__icon`}
            />
            {prompt.label}
        </Button>
    );
};

export default ChatPromptSuggestionButton;
